import { UPDATE_SMART_PROMOTION, FETCH_SMART_PROMOTIONS, CREATE_SMART_PROMOTION } from '../types';
import api from '../api';

export const fetchSmartPromotions = (menuId, branchIdForOverride, onSuccess) => {
    return {
        type: FETCH_SMART_PROMOTIONS,
        payload: api.menus.get(menuId, branchIdForOverride).smartPromotions.fetch(),
        meta: { onSuccess }
    };
};

export const createSmartPromotion = (upsell, branchIdForOverride) => {
    return {
        type: CREATE_SMART_PROMOTION,
        payload: api.menus.get(upsell.menuId, branchIdForOverride).smartPromotions.create(upsell),
        meta: {
            toastSuccess: true
        }
    };
};


export const updateSmartPromotion = (upsell, branchIdForOverride) => {
    return {
        type: UPDATE_SMART_PROMOTION,
        payload: api.menus.get(upsell.menuId, branchIdForOverride).smartPromotions.update(upsell),
        meta: {
            toastSuccess: true
        }
    };
};
